import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

function formatTechnicianNotes(notes: string | null | undefined): string {
  const trimmed = notes?.trim();
  if (!trimmed) {
    return 'Keine Anmerkungen.';
  }
  return trimmed;
}

export function TechnicianNotesCard({ notes }: { notes: string | null | undefined }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Anmerkungen des Monteurs</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm whitespace-pre-wrap text-muted-foreground">
          {formatTechnicianNotes(notes)}
        </p>
      </CardContent>
    </Card>
  );
}
